module.exports = "<ng-content select=\"\"></ng-content>";